import * as R from "ramda";
import React, {Component} from "react";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import MasterLogistikTable from "../common/masterLogistikTable";
import {formGroupSubSegmen, tableConfig} from "../config";
import MasterLogistikSubSegmenModifying from "./modal/MasterLogistikMotorSubSegmenModifying";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL} from "../../../common/mapper";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class MasterLogistikMotorSubSegmen extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = tableConfig.subsegmen;
        this.state = {
            modifyingVisible: false,
            selectedData: null,
            dataSegmenDDL: [],
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataSubSegmen();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = async (index) => {
        this.handleTriggerLoading();
        if (!this.state.modifyingVisible) {
            await this.fetchDataSegmen();
        }

        if (!R.isNil(index)) {
            let id = this.state.dataTable[index].id;
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getSubSegmenById,
                menuName: "Master Logistik Motor - Sub Segmen",
                setError: this.props.setError,
                args: id,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...res.data.data,
                        idSegment: {
                            label: res.data.data.segmentDTO.segmentName,
                            value: res.data.data.segmentDTO.id,
                        }
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            idSegment: getValueFromDDL(formGroup, "idSegment"),
        };
        let api;
        if (!R.isNil(this.state.selectedData)) {
            api = Api.create("NAGAMAS_MASTER_DATA").updateSubSegmen;
        } else {
            api = Api.create("NAGAMAS_MASTER_DATA").saveSubSegmen;
        }
        let res = await fetchDataAsync({
            asyncFn: api,
            menuName: "Master LogistikMotor - Sub Segmen",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            await this.fetchDataSubSegmen({
                paramFilters: {},
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            });
        }
        this.handleTriggerLoading();
    };

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusSubSegmen,
            menuName: "Master LogistikMotor - Sub Segmen",
            setError: this.props.setError,
            args: {id: data.id, status: data.status},
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchDataSubSegmen({
                paramFilters: {},
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            });
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        await this.fetchDataSubSegmen({paramFilters: {}, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        await this.fetchDataSubSegmen({paramFilters: {}, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    fetchDataSubSegmen = async (body) => {
        this.setState((prevValue) => ({...prevValue, pagination: {...prevValue.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0
            ? body :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            }
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSubSegmenByParam,
            menuName: "Master Logistik Motor - Sub Segmen",
            setError: this.props.setError,
            args: req,
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: response.data.data,
                pagination: {
                    ...prevState.pagination,
                    count: response.data.totalData,
                    page: req.page,
                    limit: req.limit,
                }
            }));
        }
    }


    fetchDataSegmen = async () => {
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSegmen,
            menuName: "Master Logistik Motor - Sub Segmen",
            setError: this.props.setError,
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSegmenDDL: response.data.data.map(item => mapToObjectDDL(item.segmentName, item.id)),
            }));
        }
    }

    render() {
        return (
            <>
                <MasterLogistikTable
                    tableConfig={this.tableConfig}
                    menuAccess={this.props.menuAccess}
                    data={this.state.dataTable}
                    onEdit={this.handleModifyingModalVisibility}
                    onChangeStatus={this.handleChangeStatus}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    additionalButtons={
                        this.props.menuAccess && this.props.menuAccess.createAccess && (
                            <SimpleButton
                                onClick={() => this.handleModifyingModalVisibility()}
                                icon={<i className="fa fa-plus margin-right-10px"></i>}
                                text={"Tambah"}
                            />
                        )
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterLogistikSubSegmenModifying
                        formGroup={formGroupSubSegmen}
                        initialValues={this.state.selectedData}
                        selectedData={this.state.selectedData}
                        dataSegmenDDL={this.state.dataSegmenDDL}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default MasterLogistikMotorSubSegmen;
